export default "__VITE_ASSET__0a912886__"